import React, { PropTypes } from 'react';
import cx from './TabFilter.scss';

import withStyles from 'decorators/withStyles';

@withStyles(cx)
export default class TabFilter extends React.Component {

	static propTypes = {
		items: PropTypes.object.isRequired,
		value: PropTypes.string.isRequired,
		onChange: PropTypes.func,
		className: PropTypes.string,
	};

	render() {
		const { items, value, className = '', onChange } = this.props;

		return (
			<div className={`${className} ${cx('main')}`}>
				<div className={cx('items')}>
					{items.map((label, itemValue) => (
						<label className={cx('item')} key={itemValue}>
							<input
								type="radio"
								checked={itemValue === value}
								className={cx('inp')}
								onChange={() => onChange(itemValue)}
								/>
							<span className={cx('lbl')}>{label}</span>
						</label>
					)).toArray()}
				</div>
			</div>
		);
	}

}



// WEBPACK FOOTER //
// ./src/react/components/GoalsSearch/TabFilter.js